module.exports = __webpack_public_path__ + "img/back.85cecb0e.svg";